import history from '../../../utils/history/history';
import navigation from '../../../constants/navigation';

function lessonIsEnded() {
  if (!this.isRelevant) {
    return;
  }

  this.queue?.clearAllTaskImmediately();
  this.mediasoup?.stopMediaTransfer();
  history.push(navigation.lessonEnd.pathWithSearch);
}

export default lessonIsEnded;
